/**
 * The October 2026 full-access trial (TED: user/trial_full_access.py).
 *
 * Non-paying accounts were given ORTEX Advanced, the Options Platform and the
 * Index Rebalance add-on for free until the end of October, with a 50% / 6-month
 * offer to keep it. The backend sends `trial_full_access` / `trial_full_access_ends`
 * on /API/v2/user while the trial is the reason the account has its access.
 */

/** Promo code of the keep-your-access offer (Stripe promotion code KEEP50). */
export const TRIAL_KEEP_OFFER_CODE = "KEEP50";

/**
 * Where "keep your access" sends a signed-in trial holder: /upgrade forwards an
 * authenticated user to the checkout modal with the promo applied. `t=monthly`
 * because the coupon halves every invoice in its 6 months, which on the annual
 * plan would halve the whole first year.
 */
export const TRIAL_KEEP_OFFER_HREF = `/upgrade?promo=${TRIAL_KEEP_OFFER_CODE}&t=monthly&checkout=true`;

/**
 * "31 October 2026" for an `ends` of "2026-11-01": the group is removed from
 * midnight London on the end date, so the last day of access is the day before.
 */
export const formatTrialEnd = (ends?: string): string => {
    if (!ends) return "the end of October";
    const [year, month, day] = ends.split("-").map(Number);
    if (!year || !month || !day) return "the end of October";
    const lastDay = new Date(Date.UTC(year, month - 1, day - 1));
    return lastDay.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });
};
